module.exports = __webpack_public_path__ + "img/photo-0139.45de6ae4.jpg";